/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Table, {Row, Column} from 'components/Table';
import Code from 'components/Code';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: _jsx(_components.code, {
        children: "StyleSheetManager"
      })
    }), "\n", _jsx(_components.p, {
      children: "A helper component for modifying how your styles are processed. For a given subtree involving styled-components, you can customize various behaviors like how the CSS runtime processor (stylis) handles styles via userland plugins and option overrides."
    }), "\n", _jsxs(Table, {
      head: ['Props', 'Description'],
      children: [_jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "disableCSSOMInjection (v5+)"
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "Switches to the slower text node-based CSS injection system for adding styles to the DOM. Useful for integrating with third party tools that haven't been upgraded to consume styles from the CSSOM APIs."
          })
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "disableVendorPrefixes (v5, removed in v6)"
          })
        }), _jsx(Column, {
          children: "Opts the given subtree out of adding legacy CSS properties for rendered components."
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "enableVendorPrefixes (v6+)"
          })
        }), _jsx(Column, {
          children: "Opts the given subtree into adding legacy CSS properties for rendered components."
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "sheet"
          })
        }), _jsx(Column, {
          children: _jsxs(_components.p, {
            children: [_jsx("em", {
              children: "Thar be dragons ahead."
            }), " Create and provide your own StyleSheet if necessary for advanced SSR scenarios."]
          })
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "stylisPlugins (v5+)"
          })
        }), _jsxs(Column, {
          children: [_jsxs(_components.p, {
            children: ["An array of plugins to be run by stylis during compilation. Check out", ' ']
          }), _jsx("a", {
            href: "https://www.npmjs.com/search?q=keywords%3Astylis",
            target: "_blank",
            children: _jsx(_components.p, {
              children: "what's available on npm"
            })
          }), _jsx(_components.p, {
            children: "."
          })]
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "target"
          })
        }), _jsx(Column, {
          children: _jsxs(_components.p, {
            children: [_jsx("em", {
              children: "Thar be dragons ahead."
            }), " Provide an alternate DOM node to inject styles info."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "For example if your app is intended for legacy browsers, you may want to enable vendor prefixing for your styles:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled, { StyleSheetManager } from 'styled-components'\n\nconst Box = styled.div`\n  color: ${props => props.theme.color};\n  display: flex;\n`\n\nrender(\n  <StyleSheetManager enableVendorPrefixes>\n    <Box>If you inspect me, there are vendor prefixes for the flexbox style.</Box>\n  </StyleSheetManager>\n)\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Another example would be enabling right-to-left translation for your styles via the userland ", _jsx(_components.code, {
        children: "stylis-plugin-rtl"
      }), " plugin:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled, { StyleSheetManager } from 'styled-components'\n// import stylisRTLPlugin from 'stylis-plugin-rtl';\n\nconst Box = styled.div`\n  background: mediumseagreen;\n  border-left: 10px solid red;\n`\n\nrender(\n  <StyleSheetManager stylisPlugins={[stylisRTLPlugin]}>\n    <Box>My border is now on the right!</Box>\n  </StyleSheetManager>\n)\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
